





























import * as dialog$ from '@/subjects/dialog';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component
export default class UiDialog extends Vue {
  public showDialog: boolean = false;
  public dialog: dialog$.IAlert = null;

  public dialogColor: string = '';
  public okButtonColor: string = '';
  public cancelButtonColor: string = '';
  public btnSolid = false;
  justification = null;

  public beforeMount(): void {
    dialog$.get().subscribe((data) => {
      if (!data) {
        this.showDialog = false;
        this.dialog = undefined;
        return;
      }

      this.dialog = this.formatDefaultValues(data);
      this.showDialog = true;
      this.justification = null;
    });
  }

  @Watch('showDialog')
  onShowDialog() {
    setTimeout(() => {
      let elem: any = this.$refs['justification'];
      let btnPrimary: any = this.$refs['btnPrimary'];
      let btnSecondary: any = this.$refs['btnSecondary'];
      if (elem) {
        elem.focus();
      } else if(!btnSecondary && btnPrimary) {
        btnPrimary.$el.focus();
      }
    }, 200);
  }

  public onOkClick(): void {
    this.showDialog = false;
    if (!!this.dialog.primaryCallback) {
      this.dialog.primaryCallback(true, this.justification);
    }
    dialog$.close();
  }

  public onCancelClick(): void {
    this.showDialog = false;
    if (!!this.dialog.secondaryCallback) {
      this.dialog.secondaryCallback(false);
    }
    dialog$.close();
  }

  public formatDefaultValues(data: dialog$.IAlert) {
    data.primaryText = data.primaryText || 'Ok';
    data.primaryCallback = data.primaryCallback || '';
    data.secondaryCallback = data.secondaryCallback || '';

    const [
      dialogColor,
      okButtonColor,
      cancelButtonColor,
    ] = this.convertDialogColors(data.type);

    this.dialogColor = dialogColor;
    this.okButtonColor = data.okButtonColor || okButtonColor;
    this.cancelButtonColor = data.cancelButtonColor || cancelButtonColor;
    this.btnSolid = data.btnSolid;

    return data;
  }

  private convertDialogColors(
    type: dialog$.IAlert['type'],
  ): [string, string, string] {
    switch (type) {
      case 'alert':
        return ['white', 'green darken-2 flat', 'grey'];
      case 'warn':
        return ['amber darken-1 white--text', 'white', 'amber lighten-3'];
      case 'error':
        return ['red darken-2 white--text', 'white', 'red lighten-3'];
    }
  }
}
